import React, { useMemo } from 'react';
import { useGetBuslinesInfinite } from '@area-restrita/api-client/endpoints/buslines/buslines.gen';

import DataTableFacetedFilter, {
  IDataTableFacetedFilterProps,
} from '../DataTable/DataTableFacetedFilter';

type IProps = Omit<IDataTableFacetedFilterProps<any, any>, 'options'>;

const BuslineQueryFilter: React.FC<IProps> = (props) => {
  const query = useGetBuslinesInfinite(
    { limit: 1000, page: 1 },
    {
      query: {
        queryKeyHashFn: (args) => JSON.stringify(['infinite', ...args]),
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const buslines = useMemo(
    () =>
      query.data?.pages.flatMap((page) =>
        page.data.map((busline) => ({
          label: `${busline.code} - ${busline.name}`,
          value: busline.id,
        })),
      ) ?? [],
    [query.data],
  );

  return <DataTableFacetedFilter options={buslines} {...props} />;
};

export default BuslineQueryFilter;
